import { css } from "styled-components";

// 버튼 타입을 정의하는 인터페이스
export interface ButtonProps {
  $variant: "positive" | "negative" | "default" | null;
  $weight?: number;
  $isSelected?: boolean;
}

export const getButtonStyle = ($variant: ButtonProps["$variant"]) => {
  switch ($variant) {
    case "positive":
      return css`
        background: rgba(127, 37, 251, 1);
        color: white;
      `;
    case "negative":
      return css`
        background: rgba(190, 190, 190, 1);
        color: white;
      `;
    default:
      return css`
        background: rgba(255, 255, 255, 1);
        color: gray;
      `;
  }
};

export const getHoverButtonStyle = ($variant: ButtonProps["$variant"]) => {
  switch ($variant) {
    case "positive":
      return css`
        background: white;
        color: black;
      `;
    case "negative":
      return css`
        background: rgba(190, 190, 190, 1);
        color: white;
      `;
    default:
      return css`
        background: rgba(0, 0, 0, 1);
        color: white;
      `;
  }
};

export const getActiveButtonStyle = ($variant: ButtonProps["$variant"]) => {
  switch ($variant) {
    case "positive":
      return css`
        background: rgba(255, 255, 255, 1);
        color: black;
      `;
    case "negative":
      return css`
        background: rgba(190, 190, 190, 1);
        color: white;
      `;
    default:
      return css`
        background: rgba(0, 0, 0, 1);
        color: white;
      `;
  }
};

export const getActiveItemStyle = ($variant: ButtonProps["$variant"]) => {
  switch ($variant) {
    case "positive":
      return css`
        background: rgba(255, 255, 255, 1);
        color: black;
      `;
    case "negative":
      return css`
        background: rgba(190, 190, 190, 1);
        color: white;
      `;
    default:
      return css`
        background: rgba(0, 0, 0, 1);
        color: white;
      `;
  }
};

export const getHoverItemStyle = ($variant: ButtonProps["$variant"]) => {
  switch ($variant) {
    case "positive":
      return css`
        background: rgba(255, 255, 255, 1);
        color: black;
      `;
    case "negative":
      return css`
        background: rgba(190, 190, 190, 1);
        color: white;
      `;
    default:
      return css`
        background: rgba(0, 0, 0, 1);
        color: white;
      `;
  }
};
